import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'

import {
    fetchLocationsMngtList,
    addLocationOption,
    selAllLocationOptions,
    selSelLocationOptions,
    unSelLocationOption,
    unSelAllLocationOptions,
    updateLocations,
    fetchLocationsMngtError,
    errorLocationsMngt
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './Locations.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;

class Locations extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            notify: false,
            curProp: 'holidayTypes'
        };

        this.fetchLocationsMngtErrorClear = this.fetchLocationsMngtErrorClear.bind(this);

        this.errorLocationMngtClear = this.errorLocationMngtClear.bind(this);

        this.newProp = this.newProp.bind(this);

        this.addOption = this.addOption.bind(this);

        this.selAll = this.selAll.bind(this);
        this.selSel = this.selSel.bind(this);
        this.unSel = this.unSel.bind(this);
        this.unSelAll = this.unSelAll.bind(this);

        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);

        this.cancelLocations = this.cancelLocations.bind(this);
        this.closeLocations = this.closeLocations.bind(this);
    }

    componentDidMount() {
        var opts = document.getElementById('options')

        setTimeout(function () { opts.size = opts.length }, 100)
    }

    fetchLocationsMngtErrorClear() {
        this.props.dispatch(fetchLocationsMngtError);
    }

    errorLocationMngtClear() {
        this.props.dispatch(errorLocationsMngt);
    }

    newProp(e) {
        var opts = document.getElementById('options')

        $('input#newavail').val('')
        this.setState({ curProp: e.target.value })
        setTimeout(function () { opts.size = opts.length }, 100)
    }

    addOption() {
        if (this.props.locations.fetching) return

        if ($('input#newavail').val().length) {
            var newopt = ''
            var opts = document.getElementById('options')
            var opt = $('input#newavail').val().toLowerCase()

            opt = opt.split(' ')
            opt.map((op) => {
                if (newopt.length) newopt += ' '
                op = op.charAt(0).toUpperCase() + op.substring(1)
                newopt += op
            })

            addLocationOption.bind(this)(this.state.curProp, newopt)
            $('input#newavail').val('')

            setTimeout(function () { opts.size = opts.length }, 100)
        }
    }

    optSelect(e) {
        $('li').each(function () {
            $(this).removeClass('selected');
        })
        e.target.className = "selected";
    }

    selAll(e) {
        if (this.props.locations.fetching) return

        var opts = document.getElementById('options')

        selAllLocationOptions.bind(this)(this.state.curProp)

        setTimeout(function () { opts.size = opts.length }, 100)
    }
    selSel(e) {
        if (this.props.locations.fetching) return

        let sels;
        let opts = []

        sels = $('select.multibox').val()

        if (sels && sels.length) {
            selSelLocationOptions.bind(this)(this.state.curProp, sels)

            $('select.multibox').val([]);
        }
    }
    unSel(e) {
        if (this.props.locations.fetching) return

        let sel;
        var opts = document.getElementById('options')

        sel = $('li.selected');

        if (sel.length) {
            unSelLocationOption.bind(this)(this.state.curProp, sel.text())

            sel.removeClass('selected');
        }

        setTimeout(function () { opts.size = opts.length }, 100)
    }
    unSelAll(e) {
        if (this.props.locations.fetching) return

        var opts = document.getElementById('options')

        unSelAllLocationOptions.bind(this)(this.state.curProp)

        setTimeout(function () { opts.size = opts.length }, 100)
    }

    onCancel() {
        this.setState({ notify: false })
        $('select#types').val('holidayTypes')

        fetchLocationsMngtList.bind(this)()
        chkReturn = setInterval(this.cancelLocations, 100);
    }

    cancelLocations() {
        if (this.props.locations.fetched || this.props.locations.error) {
            if (this.props.locations.fetched) {
                var opts = document.getElementById('options')
                opts.size = opts.length
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    onSubmit() {
        updateLocations.bind(this)(this.props.locations.locations)

        chkReturn = setInterval(this.closeLocations, 100);
    }

    closeLocations() {
        if (this.props.locations.fetched || this.props.locations.error) {
            if (this.props.locations.fetched) {
                this.setState({ notify: true })
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }

    render() {
        return (
            <div className="locationsmngt col-xs-12">
                <CommError error={this.props.locations.error} onClose={this.fetchLocationsMngtErrorClear} />
                <ConfirmModal open={this.state.notify} heading={"Location Management Admin"} msg={"Submit Successful"} notifyOnly={true} onYes={this.onCancel} />

                <div className="headWrapper">
                    <div className="product">
                        <h1>Location Management Admin</h1>
                    </div>
                </div>
                <div className="tableWrapper">
                    {
                        this.props.locations.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                </div>

                <div className="locationsmngt col-sm-6">
                    {
                        this.props.locations.fetching ?
                            <select id="types" disabled>
                                <option value="holidayTypes">Holiday Type</option>
                                <option value="locationGroupTypes">Location Group Type</option>
                            </select>
                        :
                            <select id="types" onChange={this.newProp}>
                                <option value="holidayTypes">Holiday Type</option>
                                <option value="locationGroupTypes">Location Group Type</option>
                            </select>
                    }
                    <div className="selections">
                        <div className="opts-box">
                            <p>Available</p>
                            {
                                this.props.locations.fetching ?
                                    <input id="newavail" disabled/>
                                :
                                    <input id="newavail" spellcheck="false" />
                            }
                            <div className="opts-box-buttons">
                                <button className="multibox btn" onClick={this.addOption}><i className="fa fa-plus"></i></button>
                            </div>

                            {
                                this.props.locations.fetching ?
                                    <select id="options" className="multibox form-control" multiple disabled>
                                        {
                                            this.props.locations.locations[this.state.curProp] ?
                                                this.props.locations.locations[this.state.curProp].filter((prop) => { return !prop.active })
                                                    .map((prop) => {
                                                        return this.state.curProp == 'holidayTypes' ?
                                                            <option>{prop.holidayTypeName}</option> :
                                                            <option>{prop.locationGroupTypeName}</option>
                                                    })
                                                : null
                                        }
                                    </select>
                                :
                                    <select id="options" className="multibox form-control" multiple>
                                        {
                                            this.props.locations.locations[this.state.curProp] ?
                                                this.props.locations.locations[this.state.curProp].filter((prop) => { return !prop.active })
                                                    .map((prop) => {
                                                        return this.state.curProp == 'holidayTypes' ?
                                                            <option>{prop.holidayTypeName}</option> :
                                                            <option>{prop.locationGroupTypeName}</option>
                                                    })
                                                : null
                                        }
                                    </select>
                            }
                            <div className="opts-box-buttons">
                                <button className="multibox btn" onClick={this.selAll}><i className="fa fa-angle-double-right"></i></button>
                                <button className="multibox btn" onClick={this.selSel}><i className="fa fa-angle-right"></i></button>
                                <button className="multibox btn" onClick={this.unSel}><i className="fa fa-angle-left"></i></button>
                                <button className="multibox btn" onClick={this.unSelAll}><i className="fa fa-angle-double-left"></i></button>
                            </div>
                        </div>

                        <div className="opts-box">
                            <p>Selected</p>
                            {
                                this.props.locations.fetching ?
                                    <ul className="form-control" disabled>
                                        {
                                            this.props.locations.locations[this.state.curProp] ?
                                                this.props.locations.locations[this.state.curProp].filter((prop) => { return prop.active })
                                                    .map((prop) => {
                                                        return this.state.curProp == 'holidayTypes' ?
                                                            <li onClick={this.optSelect}>{prop.holidayTypeName}</li> :
                                                            <li onClick={this.optSelect}>{prop.locationGroupTypeName}</li>
                                                    })
                                                : null
                                        }
                                    </ul>
                                :
                                    <ul className="form-control">
                                        {
                                            this.props.locations.locations[this.state.curProp] ?
                                                this.props.locations.locations[this.state.curProp].filter((prop) => { return prop.active })
                                                    .map((prop) => {
                                                        return this.state.curProp == 'holidayTypes' ?
                                                            <li onClick={this.optSelect}>{prop.holidayTypeName}</li> :
                                                            <li onClick={this.optSelect}>{prop.locationGroupTypeName}</li>
                                                    })
                                                : null
                                        }
                                    </ul>
                            }
                        </div>
                    </div>

                    <div className="button-group">
                        <a className="btn btn-default" onClick={this.onCancel}>Cancel</a>
                        {
                            this.props.locations.fetching ?
                                <button className="btn btn-primary" disabled>Submit</button>
                            :
                                <button className="btn btn-primary" onClick={this.onSubmit}>Submit</button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    locations: state.locationsMngt
});

export default connect(mapStateToProps)(Locations)